import axios from "axios"
const route = 'system/configuration'
const  Cost = {
   namespaced: true,

   state: () => ({

   }),

   getters: {

   },

   mutations: {

   },
   actions:{
      getCosts(){
        return axios.get(`helper/get_all_costs`)
      },
      save(context,configuration){
         return axios.post(route,configuration)
      },
      index(){
        return axios.get(route)
      }

   }

}

export default Cost
